import React from 'react';
import { Sparkles, CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
import { ACTIVITIES } from './summerCampContent';
export function SummerCampWhatKidsDo() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-3331">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3332">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-3333">
          <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[4/5]" data-id="element-3334">
            <img src={SITE_IMAGES.summerCamp} alt="Kids participating in Storm Taekwondo summer camp" className="block w-full h-full object-cover" data-id="element-3335" />
            <div className="absolute bottom-6 left-6 bg-storm-red text-white px-4 py-2 rounded-full font-bold uppercase tracking-wide text-sm shadow-lg" data-id="element-3336">
              <Sparkles className="w-4 h-4 inline mr-2" data-id="element-3337" />
              Active Days
            </div>
          </div>

          <div data-id="element-3338">
            <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-3339">
              What Kids Do at Storm Summer Camp
            </h2>
            <p className="text-lg text-gray-warm mb-8 leading-relaxed" data-id="element-3340">
              Each day is filled with a balanced mix of active games, movement,
              teamwork and rest. Kids stay active without burning out.
            </p>

            <div className="grid grid-cols-2 gap-3" data-id="element-3341">
              {ACTIVITIES.map((activity, idx) => <div key={idx} className="flex items-center gap-3 bg-off-white p-4 rounded-xl border border-subtle-gray" data-id="element-3342">
                  <div className="w-8 h-8 bg-storm-red rounded-lg flex items-center justify-center shrink-0" data-id="element-3343">
                    <CheckCircle2 className="w-5 h-5 text-white" data-id="element-3344" />
                  </div>
                  <span className="text-ink font-bold text-sm" data-id="element-3345">{activity}</span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}